export default "dist/images/block-feature-grid-horizontal.dfa11b7.png";